import {CompetitionPageMetaDataModel} from "../../../models/competition-page.meta-data.model";
import {computed} from "mobx";
import {METADATA_FILTERS} from "../../../../../core/models/metatdata/metadata-filters.consts";

export class CompetitionBracketsPageRouteMetaDataModel extends CompetitionPageMetaDataModel {
  @computed get pageTitle() {
    let title = this.staticTitle;

    if (this.titleSection) {
      title = this.titleSection.getElementValue(METADATA_FILTERS.COMPETITION.brackets)
    }

    return title
  }

  @computed get description(): String {
    let description = this.staticDescription;

    if (this.descriptionSection) {
      description = this.descriptionSection.getElementValue(METADATA_FILTERS.COMPETITION.brackets)
    }

    return description
  }

  get staticTitle() {
    const staticTitle = this.websiteTerms.COMPETITION_BRACKET_TITLE_TEMPLATE.format({
      COMPETITION_NAME: this.competitionName,
      SPORT_TYPE: this.competitionSportName,
      BRACKET_NAME: this.bracketsName,
      COMPETITION_BRACKET_NAME: this.bracketsName
    });

    return staticTitle
  }

  get staticDescription() {
    return this.websiteTerms.COMPETITION_BRACKET_DESCRIPTION.format({
      "LIVESCORE_MAIN_KEYWORD": this.websiteTerms.LIVESCORE_MAIN_KEYWORD,
      "COMPETITION_NAME": this.competitionName,
      "BRACKET_NAME": this.bracketsName,
      "COMPETITION_BRACKET_NAME": this.bracketsName,
    });
  }
}